import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';

import { CelumPropertiesProvider } from '@celum/core';
import { SearchSpecification, SpecificationList } from '@celum/formats/domain';

import { NotificationService } from './notification.service';
import { SpecificationContractServiceBase } from './specification-contract-service-base';

@Injectable()
export class SpecificationDefinitionsService extends SpecificationContractServiceBase {
  private notificationService = inject(NotificationService);

  private static readonly LOAD_ERROR_KEY = 'FORMAT_LIST.SNACKBAR.LOAD_SPEC_ERROR';

  private get baseApiUrl(): string {
    return `${CelumPropertiesProvider.properties.appProperties.formats.apiUrl}/definitions`;
  }

  public getSpecifications(search?: SearchSpecification): Observable<SpecificationList> {
    return this.withContext(context =>
      this.http.get<SpecificationList>(`${this.baseApiUrl}/specifications`, { params: this.buildSearchParams(search), context }).pipe(
        catchError(error => {
          console.error('SpecificationDefinitionsService: error on getSpecifications', error.error);
          this.notificationService.error(error.error?.errorMessage || SpecificationDefinitionsService.LOAD_ERROR_KEY);
          return of({ content: [], totalElements: 0, hasNext: false } as SpecificationList);
        })
      )
    );
  }

  private buildSearchParams(search?: SearchSpecification): HttpParams {
    let params = new HttpParams();
    if (!search) {
      return params;
    }

    if (search.page !== undefined) {
      params = params.set('page', search.page);
    }
    if (search.size !== undefined) {
      params = params.set('size', search.size);
    }
    (search.specificationIds ?? []).forEach(id => (params = params.append('specificationIds', id)));
    (search.specificationKeys ?? []).forEach(key => (params = params.append('specificationKeys', key)));
    (search.specificationTypes ?? []).forEach(type => (params = params.append('specificationTypes', type)));

    return params;
  }
}
